import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import CcpaCookieBanner from "web/react/components/ccpa-cookie-banner/ccpa-cookie-banner";
import FollowStickyBanner from "web/react/components/follow-sticky-banner/follow-sticky-banner";
import withReduxProvider from "web/react/redux-provider";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";
import { languageIsEnglish } from "web/script/modules/language";
import userProfiler from "web/script/modules/userprofiler";
import { ProfileHeaderSerializer, ShopHeaderSerializer } from "web/types/serializers";
import styles from "./banner-container.module.css";

interface BannerContainerReduxStateProps {
    showDUBanner: boolean;
    disableDUBanner: boolean;
    feedProfile?: ProfileHeaderSerializer & ShopHeaderSerializer;
}

function mapStateToProps(state): BannerContainerReduxStateProps {
    const {
        profile: feedProfile,
        show,
        bannerDisable: disableDUBanner,
    } = state.followDesignerBannerReducer;

    const showDUBanner = show;

    return { feedProfile, showDUBanner, disableDUBanner };
}

export function BannerContainer({
    feedProfile,
    showDUBanner,
    disableDUBanner,
}: BannerContainerReduxStateProps): JSX.Element {
    const pageSubType = environment.get("pageSubType");
    const [showCcpaCookieBanner, setShowCcpaCookieBanner] = useState<boolean>(false);

    useEffect(() => {
        // userProfiler isn't available in Hypernova so just set the flag once mounted
        const isPrivacyPolicyPage = pageSubType === "privacy_policy";
        const isCheckoutPage = environment.get("pageType") === "checkout";
        setShowCcpaCookieBanner(
            environment.get("country") === "US" &&
                !userProfiler.getCcpaCookieBannerDismissed() &&
                !isPrivacyPolicyPage &&
                !isCheckoutPage
        );
    }, [pageSubType]);

    const isOnDesignerFeed = pageSubType && pageSubType.startsWith("designer");
    const notFollowedText = isOnDesignerFeed
        ? gettext("designer_updates.get_designer_updates_btn_text")
        : gettext("feed.store_updates.cta");

    function onCcpaCookieBannerClose(): void {
        analytics.event("cookie_banner", "dismissed", "ccpa_banner");
        userProfiler.setCcpaCookieBannerDismissed(true);
        setShowCcpaCookieBanner(false);
    }

    return (
        <div className={styles.container}>
            {languageIsEnglish() &&
                !disableDUBanner &&
                showDUBanner &&
                feedProfile &&
                feedProfile.follow_button &&
                feedProfile.follow_button.is_authenticated !== "true" && (
                    <FollowStickyBanner
                        forceDisplay={showDUBanner}
                        lystId={feedProfile.follow_button.lyst_id}
                        isAuthenticated={feedProfile.follow_button.is_authenticated}
                        isFollowing={feedProfile.follow_button.is_following}
                        notFollowedText={notFollowedText}
                        profileImage={feedProfile.small_photo_url}
                        followedText={feedProfile.follow_button.followed_text}
                        designerName={feedProfile.follow_button.designer_name}
                        feedTitle={
                            feedProfile.title ||
                            feedProfile.name ||
                            feedProfile.follow_button.designer_name
                        }
                        productTaxonomy={feedProfile.follow_button.product_taxonomy}
                    />
                )}
            {showCcpaCookieBanner && (
                <CcpaCookieBanner onCloseButtonClick={onCcpaCookieBannerClose} />
            )}
        </div>
    );
}

export default withReduxProvider(connect(mapStateToProps)(BannerContainer));
